import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// In test environments the env vars are not present — the module is mocked at the test layer.
// In production/development a missing key is a fatal misconfiguration.
if (import.meta.env.MODE !== 'test' && (!url || !anonKey)) {
  throw new Error(
    'Missing Supabase env vars: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY required'
  );
}

export const supabase = createClient(url ?? 'http://localhost', anonKey ?? 'test-key', {
  auth: { persistSession: true, autoRefreshToken: true },
});

// IMPORTANT: service role key MUST NEVER appear in this file or any src/ file
